export const dispatchCustomEvent = (eventName, eventData = {}) => {
  // Create a new custom event with the specified name and optional data
  const customEvent = new CustomEvent(eventName, {
    detail: eventData,
  })

  // Dispatch the custom event on a target element
  document.dispatchEvent(customEvent) // Dispatching on the document, but you can use any event target
}
